var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 40,
    height: 40,
    rx: 5,
    transform: "rotate(-90 0 40)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.167 15.334h11.666a4.667 4.667 0 0 1 4.667 4.667v4.666a4.667 4.667 0 0 1-4.667 4.667H14.167A4.667 4.667 0 0 1 9.5 24.667v-4.666a4.667 4.667 0 0 1 4.667-4.667z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.881 12.453a.875.875 0 0 1 0-1.238l3.5-3.5a.875.875 0 0 1 1.238 0l3.5 3.5a.875.875 0 1 1-1.238 1.238l-2.006-2.007v11.888a.875.875 0 0 1-1.75 0V10.446l-2.006 2.007a.875.875 0 0 1-1.238 0z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.24eda953a18a87849f16b2ab8a544105.svg";
export { ForwardRef as ReactComponent };